/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import { StatusTableController } from './status-table.controller';

export default angular.module('tektelic.status-table', [])
    .controller('StatusTableController', StatusTableController)
    .name;



// WEBPACK FOOTER //
// ./src/app/status-table/index.js